import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1b6d94bf"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  id: "vue",
  style: {
    "padding": "8px"
  }
};
const _hoisted_3 = {
  class: "retList"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 点击选择号码！", -1));
const _hoisted_6 = {
  class: "num"
};
const _hoisted_7 = {
  class: "btn"
};
const _hoisted_8 = {
  class: "blank"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "font-weight": "800",
    "color": "#ed8f26"
  }
}, "复式组数", -1));
const _hoisted_10 = {
  style: {
    "color": "#f00"
  }
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  class: "blank"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "font-weight": "800",
    "color": "#ed8f26"
  }
}, "三中二（中奖组数）", -1));
const _hoisted_16 = {
  class: "zj"
};
const _hoisted_17 = {
  style: {
    "color": "red"
  }
};
const _hoisted_18 = {
  class: "blank"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "font-weight": "800",
    "color": "#ed8f26"
  }
}, "三中三（中奖组数）", -1));
const _hoisted_20 = {
  class: "zj"
};
const _hoisted_21 = {
  style: {
    "color": "red"
  }
};
const _hoisted_22 = {
  class: "blank"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "font-weight": "800",
    "color": "#ed8f26"
  }
}, "四中四（中奖组数）", -1));
const _hoisted_24 = {
  class: "zj"
};
const _hoisted_25 = {
  style: {
    "color": "red"
  }
};
const _hoisted_26 = {
  key: 0,
  style: {
    "margin-left": "-8px",
    "max-width": "800px",
    "position": "fixed",
    "top": "50%",
    "width": "100%",
    "text-align": "center",
    "background": "#00000094",
    "color": "#fff",
    "line-height": "42px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.balls, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      key: i
    }, [_createElementVNode("span", {
      class: _normalizeClass('css' + item + ' c' + $data.balli[i]),
      onClick: $event => $options.select(i)
    }, _toDisplayString(item), 11, _hoisted_4)]);
  }), 128))]), _hoisted_5, _createElementVNode("div", _hoisted_6, _toDisplayString($data.nums.join(',')), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = $event => $options.cal())
  }, "查询"), _createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = $event => $options.copy())
  }, "复制"), _createElementVNode("div", {
    onClick: _cache[2] || (_cache[2] = $event => $options.clear())
  }, "清空")]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fsList, v => {
    return _openBlock(), _createElementBlock("li", {
      style: {
        "border-bottom": "solid 1px #aeaeae"
      },
      key: v.name
    }, [_createTextVNode(_toDisplayString(v.name) + "：", 1), _createElementVNode("span", _hoisted_10, _toDisplayString(v.n), 1), _createTextVNode(" 组 "), _createVNode(_Transition, {
      name: "fade"
    }, {
      default: _withCtx(() => [_createElementVNode("span", {
        class: _normalizeClass(v.i ? 'ico down' : 'ico'),
        onClick: $event => v.i = !v.i
      }, null, 10, _hoisted_11)]),
      _: 2
    }, 1024), _createElementVNode("span", {
      style: {
        "float": "right",
        "color": "#FF5722",
        "user-select": "none"
      },
      onClick: $event => v.i = !v.i
    }, "查看所有 ", 8, _hoisted_12), v.i ? (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.arr, (item, j) => {
      return _openBlock(), _createElementBlock("p", {
        key: j
      }, _toDisplayString(item.join(',')), 1);
    }), 128))])) : _createCommentVNode("", true)]);
  }), 128))])]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("ul", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.z2list, v => {
    return _openBlock(), _createElementBlock("li", {
      key: v.name
    }, [_createElementVNode("div", null, _toDisplayString(v.name), 1), _createElementVNode("div", _hoisted_17, _toDisplayString(v.n < 1 ? '0' : v.n), 1)]);
  }), 128))])]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("ul", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.z3list, v => {
    return _openBlock(), _createElementBlock("li", {
      key: v.name
    }, [_createElementVNode("div", null, _toDisplayString(v.name), 1), _createElementVNode("div", _hoisted_21, _toDisplayString(v.n < 1 ? '0' : v.n), 1)]);
  }), 128))])]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("ul", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.z4list, v => {
    return _openBlock(), _createElementBlock("li", {
      key: v.name
    }, [_createElementVNode("div", null, _toDisplayString(v.name), 1), _createElementVNode("div", _hoisted_25, _toDisplayString(v.n < 1 ? '0' : v.n), 1)]);
  }), 128))])])]), _createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [$data.showinfo ? (_openBlock(), _createElementBlock("div", _hoisted_26, "复制成功")) : _createCommentVNode("", true)]),
    _: 1
  })])]);
}